import { useCallback } from 'react';

import { useCommentEditPersonas } from '@web/newsfeed/Article/ArticleComments/hooks/useCommentEditPersonas';
import { SubmitParams } from '@web/richText/TextEditorInner/TextEditorInner';
import { useCommentActions } from '@web/newsfeed/Article/ArticleComments/hooks/useCommentActions';
import { ArticleComment } from '@web/newsfeed/types/Article';

export const useEditCommentModal = (comment: ArticleComment | null, onClose: () => void) => {
  const { editComment } = useCommentActions();
  const pageId = comment ? comment.pageId : null;
  const { mentionPersonas } = useCommentEditPersonas(pageId);

  const onSubmit = useCallback(
    async ({ text: content, attachments }: SubmitParams) => {
      await editComment({
        id: comment.id,
        articleId: comment.articleId,
        pageId: comment.pageId,
        content,
        attachments,
      });

      onClose();
    },
    [comment, editComment, onClose]
  );

  return { onSubmit, mentionPersonas };
};
